<!--
    @Author : Luo
    @Time   : 2020/7/14 17:42
-->
<template>
  <div class="page_user_overview">
    <div class="page_overview_header flex_center">
      <div class="page_overview_header_title flex_center">
        <div class="page_overview_header_label">
          <span>账号概览</span>
        </div>
        <div class="page_overview_header_note_icon" @click="catStageDetail">
          <span>
            <svg-icon class-name="icon_down_style svg_icon_xs color_102 pointer_none"
                      icon-class="icon_info"></svg-icon>
          </span>
        </div>
        <div class="page_overview_header_note" @click="$event.stopPropagation()" v-show="stageDetail">
          <div class="page_overview_header_note_info flex_center">
            <div class="page_overview_header_note_info_header">
              <span>视频开放阶段</span>
            </div>
            <div class="page_overview_header_note_info_container flex_center">
              <div class="page_overview_header_note_info_content flex_center">
                <div class="page_overview_header_note_info_content_label"><span>二阶段</span></div>
                <div class="page_overview_header_note_info_content_main"><span>已注册GFP系统账号</span></div>
              </div>
              <div class="page_overview_header_note_info_content flex_center">
                <div class="page_overview_header_note_info_content_label"><span>三阶段</span></div>
                <div class="page_overview_header_note_info_content_main"><span>账号下至少存有两个客户信息为分析规划阶段（且其中至少包含一个“家庭”单位的信息）</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page_overview_header_team flex_center">
        <template v-if="catAccountStatus">
          <div class="input_container">
            <select @change="setTeam" v-model="teamIndex">
              <option :value="0">全部团队</option>
              <option v-for="(item, i) in teamDate"
                      :key="i"
                      :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="search_input flex_center">
            <div class="input_container">
              <input placeholder="账号" type="text" v-model="inputVal" />
            </div>
            <div class="search_btn" @click="searchVal">
              <span>查询</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="page_user_main">
      <div class="no_user_hint" v-if="JSON.stringify(tempUserDate).length <= 2"><span>{{ noDataHint }}</span></div>
      <div class="page_user_content flex_center"
           v-for="(item, i) in tempUserDate['current' + pagination.current]" :key="i">
        <div class="account_modal account_page_modal flex_center">
          <div class="page_user_container flex_center">
            <template v-if="item.firstname && item.firstname.length > 0">
              <div class="page_user_label">
                <span>用户名</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.firstname }}</span>
              </div>
            </template>
          </div>
          <div class="page_user_container flex_center">
            <template v-if="item.user && item.user.length > 0">
              <div class="page_user_label">
                <span>账号</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.user }}</span>
              </div>
            </template>
          </div>
          <div class="page_user_container flex_center">
            <template v-if="item.nickname && item.nickname.length > 0">
              <div class="page_user_label">
                <span>微信名</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.nickname }}</span>
              </div>
            </template>
          </div>
          <div class="page_user_container flex_center">
            <div class="page_user_label">
              <span>团队</span>
            </div>
            <div class="page_user_info text_ellipsis text_left">
              <span>{{ item.team }}</span>
            </div>
          </div>
          <template v-if="(item.area && item.area.length > 0) || (item.company && item.company.length > 0) || (item.certificate && item.certificate.length > 0) || (item.work_time && item.work_time.length > 0)">
            <div :class="'page_user_container flex_center more_detail ' + (moreDetail['id' + item.id] ? 'more_detail_active': '')" @click="moreDetailStatus(item.id)">
              <div class="page_user_label">
                <span>更多信息</span>
              </div>
              <div class="more_detail_icon">
                <svg-icon :className="'icon_down_style color_102 pointer_none'"
                  :iconClass="moreDetail['id' + item.id] ? 'select_up' : 'select_down'"></svg-icon>
              </div>
            </div>
          </template>
        </div>
        <div class="account_modal account_page_detail flex_center" v-show="moreDetail['id' + item.id]">
          <div class="page_user_container flex_center">
            <template v-if="item.area && item.area.length > 0">
              <div class="page_user_label">
                <span>执业区域</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.area }}</span>
              </div>
            </template>
          </div>
          <div class="page_user_container flex_center">
            <template v-if="item.company && item.company.length > 0">
              <div class="page_user_label">
                <span>所属公司</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.company }}</span>
              </div>
            </template>
          </div>
          <div class="page_user_container flex_center">
            <template v-if="item.certificate && item.certificate.length > 0">
              <div class="page_user_label">
                <span>展业证号</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.certificate }}</span>
              </div>
            </template>
          </div>
          <div class="page_user_container flex_center">
            <template v-if="item.work_time && item.work_time.length > 0">
              <div class="page_user_label">
                <span>从业时间</span>
              </div>
              <div class="page_user_info text_ellipsis text_left">
                <span>{{ item.work_time }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="account_modal account_client_modal flex_center">
          <div class="page_user_container flex_center page_user_client">
            <div class="page_user_label flex_center">
              <span>客户数量&nbsp;&nbsp;{{ item.client_total }}</span>
            </div>
            <div class="page_user_info flex_center">
              <span v-for="(clientItem, clientI) in item.client" :key="clientI">
                {{ clientI !== 0 ? '&nbsp;/&nbsp;' : '' }} {{ clientItem[0] }} {{ clientItem[1] }}
              </span>
            </div>
          </div>
        </div>
        <div class="account_modal account_video_modal flex_center">
          <div class="page_user_container flex_center">
            <div class="page_user_label">
              <span>视频开放阶段</span>
            </div>
            <div class="page_user_info flex_center">
              <span>{{ item.stage }}</span>
            </div>
          </div>
          <div class="page_user_container flex_center">
            <div class="page_user_label">
              <span>总视频观看进度</span>
            </div>
            <div class="page_user_info flex_center">
              <div class="progress_bg text_left">
              <span :class="0 <= item.progress && item.progress <= 35 ? 'progress_red' : (35 < item.progress && item.progress <= 70 ? 'progress_blue' : 'progress_green')"
                    :style="'width: ' + item.progress + '%'"></span>
              </div>
              <span style="margin-left: 15px">{{ item.progress + '%' }}</span>
            </div>
          </div>
          <div class="page_user_container flex_center">
            <div class="page_user_label">
              <span>视频观看用时</span>
            </div>
            <div class="page_user_info flex_center">
              <span>{{ setTimeType(item.time) }}</span>
            </div>
          </div>
        </div>
        <div class="account_modal account_operation_modal flex_center">
          <div class="account_analysis_type account_analysis_video">
            <div class="flex_center" @click="videoAnalysis(item)">
              <span class="account_analysis_label">视频分析</span>
            </div>
          </div>
          <div class="account_analysis_type account_analysis_page">
            <div class="flex_center" @click="pageAnalysis(item)">
              <span class="account_analysis_label">页面分析</span>
            </div>
          </div>
          <div v-if="item.is_channel && item.is_channel === '1'" class="account_analysis_type client_from_qr">
            <div class="flex_center" @click="pageFromQr(item)">
              <span class="account_analysis_label">子集列表</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <template v-if="catAccountStatus">
        <pagination :key="pagination.length" :default-current="pagination.current" :length="pagination.length" :default-amount="pagination.amount" v-on:pageCurrent="pageCurrent" />
      </template>
    </div>
  </div>
</template>

<script>
import { newMap, setTimeType, resetSpecNum, setStorage } from '@/components/common/common_js'
import { _Ajax, initLogin, logout } from '@/api/_axios'
import pagination from '@/components/pagination/index'

export default {
  name: 'user-overview',
  components: {
    pagination
  },
  data () {
    return {
      setTimeType: setTimeType,
      resetSpecNum: resetSpecNum,
      teamIndex: 0,
      tempUserDate: {},
      userDate: [],
      teamDate: [],
      noDataHint: '',
      pagination: {
        length: 0,
        amount: 10,
        current: 1
      },
      inputVal: '',
      stageDetail: false,
      moreDetail: {},
      userId: '',
      catAccountStatus: true // 如果是查看账号信息，则不可选
    }
  },
  computed: {},
  methods: {
    pageCurrent: function (data) {
      this.pagination.current = data.current
      // 选择每页显示条数的时候在刷新列表、条目及组件
      if (data.event === 'amount') {
        this.pagination.amount = data.amount
        this.setUserDate(this.userDate)
      }
      setStorage.setItem('user_brows_current', JSON.stringify({current: this.pagination.current}))
    },
    // 设置用户的数据 arr: 数组, amount: 条目
    setUserDate: function (arr) {
      let tempArr = []
      let amount = this.pagination.amount
      let tempAmount = Math.ceil(this.pagination.length / amount)
      this.tempUserDate = {}
      for (let i = 1; i <= tempAmount; i++) {
        newMap(arr, (e, j) => {
          if (amount * ((i - 1) <= 0 ? 0 : i - 1) <= j && amount * i > j) {
            tempArr.push(e)
          }
        })
        this.tempUserDate['current' + i] = tempArr
        tempArr = []
      }
    },
    // 根据选择团队设置相应的用户数据
    setTeam: function () {
      let that = this
      that.userId = ''
      that.pagination.current = 1
      setStorage.setItem('user_brows_current', JSON.stringify({current: this.pagination.current}))
      that.getUserDate()
    },
    // 页面分析
    pageAnalysis: function (e) {
      let that = this

      let queryParam = {}
      if (that.catAccountStatus) {
        queryParam = {
          team: that.teamIndex,
          id: e.id
        }
      } else {
        queryParam = {
          account: 'true',
          team: that.teamIndex,
          id: e.id,
          accountId: that.$route.query.id,
          name: that.$route.query.name
        }
      }

      that.$router.push(
        {
          path: '/home/user/page',
          query: queryParam
        }
      )
    },
    // 子集列表
    pageFromQr: function (e) {
      let that = this

      let queryParam = {}
      if (that.catAccountStatus) {
        queryParam = {
          team: that.teamIndex,
          id: e.id
        }
      } else {
        queryParam = {
          account: 'true',
          team: that.teamIndex,
          id: e.id,
          accountId: that.$route.query.id,
          name: that.$route.query.name
        }
      }

      that.$router.push(
        {
          path: '/home/user/qr',
          query: queryParam
        }
      )
    },
    // 视频分析
    videoAnalysis: function (e) {
      let that = this

      let queryParam = {}
      if (that.catAccountStatus) {
        queryParam = {
          team: that.teamIndex,
          id: e.id
        }
      } else {
        queryParam = {
          account: 'true',
          team: that.teamIndex,
          id: e.id,
          accountId: that.$route.query.id,
          name: that.$route.query.name
        }
      }

      that.$router.push(
        {
          path: '/home/user/video',
          query: queryParam
        }
      )
    },
    // 具体查询
    searchVal: function () {
      this.pagination.current = 1
      this.userId = ''
      setStorage.setItem('user_brows_current', JSON.stringify({current: this.pagination.current}))
      this.getUserDate()
    },
    // 获取用户数据
    getUserDate: function () {
      let that = this
      that.clearUserData()
      _Ajax(
        {
          method: 'get',
          url: 'data/userUseInfo?' + 'team=' + (that.teamIndex === 0 ? '' : that.teamIndex) + '&name=' + that.inputVal + '&id=' + that.userId
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '账号概览：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            // 赋值teamDate 如果已经复制则不需要再次赋值
            if (that.teamDate.length <= 0) {
              that.teamDate = res.data.team
            }
            // 赋值userDate
            newMap(
              res.data.userData,
              (item) => {
                that.userDate.push({
                  id: item.userId,
                  user: item.username,
                  firstname: item.firstname,
                  nickname: item.nickname,
                  stage: item.video_period,
                  progress: that.resetSpecNum(item.video_proportion),
                  time: item.video_time,
                  active: that.resetSpecNum(item.active_proportion),
                  client: item.client_status,
                  client_total: item.client_num_total,
                  is_channel: item.is_channel,
                  team: item.teamName,
                  company: item.work_company,
                  area: item.work_area,
                  certificate: item.work_no,
                  work_time: item.work_time_length
                })
                that.moreDetail['id' + item.userId] = false
              }
            )

            // 只有当length改变的时候，分页组件才会刷新
            that.pagination.length = that.userDate.length

            if (that.pagination.length <= 0) {
              that.noDataHint = '该团队下暂无账号'
              that.pagination.current = 1
            }

            that.setUserDate(that.userDate)
            // 如果为查看账号信息则不在存储到本地
            if (that.catAccountStatus) {
              setStorage.setItem('user_brows_date', JSON.stringify({val: that.inputVal.toString().length > 0 ? that.inputVal : '', team: that.teamIndex, id: that.userId}))
            }
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    // 查看阶段详情
    catStageDetail: function (e) {
      let that = this
      e.stopPropagation()
      that.stageDetail = !that.stageDetail
    },
    // 清空数据
    clearUserData: function () {
      let that = this

      that.noDataHint = '数据正在加载中...'
      that.pagination.length = 0
      that.userDate = []
      that.setUserDate(that.userDate)
    },
    // 更多信息
    moreDetailStatus: function (id) {
      let that = this
      that.moreDetail['id' + id] = !that.moreDetail['id' + id]
      that.moreDetail = { ...that.moreDetail }
    },
    // 测试接口是否有效
    getUser: function (call) {
      let that = this
      _Ajax(
        {
          method: 'get',
          url: '/api/profileManagement/home'
        },
        (res) => {
          if (res.status === 401) {
            that.$notice({type: 'error', content: '登录已失效，请重新登录！'})
            logout(that.$router)
          } else if (res.status === 200) {
            call()
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    }
  },
  beforeMount: function () {
    let that = this

    let tempLogoutStatus = true
    initLogin(that.$router, () => {
      tempLogoutStatus = false
    })

    if (!tempLogoutStatus) {
      that.$notice({type: 'error', content: '登录已失效，请重新登录！'})
    } else {
      that.getUser(() => {
        let tempRoute = that.$route.query
        that.teamIndex = tempRoute.team ? tempRoute.team : 0

        if (tempRoute.account && tempRoute.account === 'true') {
          that.pagination.current = 1
          that.catAccountStatus = false
          that.teamIndex = Number(tempRoute.team)
          that.inputVal = tempRoute.name
          that.userId = tempRoute.id
        } else {
          // 查看本地是否有查询记录（搜索、团队）
          let userBrowsDate = setStorage.getItem('user_brows_date') ? (JSON.parse(setStorage.getItem('user_brows_date')) ? JSON.parse(setStorage.getItem('user_brows_date')) : {}) : {}
          if (userBrowsDate.val || userBrowsDate.team || userBrowsDate.team === 0) {
            that.teamIndex = Number(userBrowsDate.team)
            that.inputVal = userBrowsDate.val
            that.userId = userBrowsDate.id
          }

          // 查看本地是否有分页记录
          let userBrowsCurrnet = setStorage.getItem('user_brows_current') ? (JSON.parse(setStorage.getItem('user_brows_current')) ? JSON.parse(setStorage.getItem('user_brows_current')) : {}) : {}
          if (userBrowsCurrnet.current) {
            that.pagination.current = Number(userBrowsCurrnet.current)
          }
        }

        that.getUserDate()
      })
    }
  },
  mounted: function () {
    let that = this
    let dom = document.querySelector('#app')
    dom.addEventListener('click', function () {
      if (that.stageDetail) {
        that.stageDetail = false
      } else {
        dom.removeEventListener('click', undefined, false)
      }
    }, false)
  }
}
</script>

<style scoped>
.page_user_overview {background: rgba(255, 255, 255, 1);border-radius: 6px;padding-bottom: 24px}
.page_overview_header {padding: 0 16px;height: 81px;justify-content: space-between}
.page_overview_header_label {white-space: nowrap}
.page_overview_header_label span {font-size: 18px;font-weight: 500;color: rgba(48, 48, 48, 1)}
.input_container select {width: 224px;height: 32px;line-height: 32px;padding: 0 14px;border: 1px solid rgba(219, 219, 219, 1);border-radius: 4px;font-size: 14px;font-weight: 400;color: rgba(40, 40, 40, 1)}
.page_user_main {padding: 0 16px}
.page_user_content {margin-bottom: 12px;padding: 24px;flex-flow: column;justify-content: flex-start;align-items: flex-start;background: rgba(248, 248, 249, 1);border-radius: 8px}
.page_user_content:not(:first-of-type) {margin-top: 12px}
.page_user_container {justify-content: flex-start}
.page_user_label span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.page_user_info {margin-left: 16px;justify-content: flex-start}
.page_user_info span {font-size: 14px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.page_user_client .page_user_label {justify-content: flex-start}
.page_user_client .select_down {margin-left: 20px}
.page_user_client .page_user_info {width: auto}
.page_user_client .page_user_info span:first-of-type {border-left: 2px solid rgba(40, 40, 40, 0);padding-left: 0;margin-left: 0}
.progress_bg {width: 120px;background-color: rgba(240, 242, 245, 1);border-radius: 3px;line-height: 0}
.progress_bg span {height: 6px;border-radius: 3px;display: inline-block}
.progress_bg .progress_red {background: rgba(245, 72, 88, 1)}
.progress_bg .progress_blue {background: rgba(76, 139, 255, 1)}
.progress_bg .progress_green {background: rgba(51, 239, 130, 1)}

.account_modal {justify-content: flex-start;width: 100%}
.account_modal:not(:first-of-type) {padding-top: 20px}
.account_operation_modal {justify-content: flex-start;margin-top: 10px}
.account_modal .page_user_info {margin-right: 20px}
.account_page_modal .page_user_container:nth-of-type(1) .page_user_info {width: 100px}
.account_page_modal .page_user_container:nth-of-type(2) .page_user_info {min-width: 100px;max-width: 250px}
.account_page_modal .page_user_container:nth-of-type(3) .page_user_info {width: 100px}
.account_page_modal .page_user_container:nth-of-type(4) .page_user_info {min-width: 100px;max-width: 120px}
.account_video_modal .page_user_container:not(:first-of-type) {margin-left: 70px}
.account_operation_modal span {color: rgba(76, 139, 255, 1)}
.account_operation_modal > div {padding: 2px 29px 2px 0}
.account_operation_modal > div:not(:first-of-type) {padding-left: 30px;border-left: 1px solid rgba(76, 139, 255, 1)}
.account_analysis_type {cursor: pointer}
.account_analysis_type .select_down {margin-left: 6px}
.account_analysis_type:hover .account_analysis_label {color: rgba(76, 139, 255, 1)}
.account_analysis_type:hover >>> svg {fill: rgba(76, 139, 255, 1)}
.account_analysis_label {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}

.search_btn {cursor: pointer;margin-left: 16px;background-color: rgba(76, 139, 255, 1);width: 70px;height: 32px;text-align: center;line-height: 32px;border-radius: 4px}
.search_btn:active {background-color: rgba(77, 135, 235, 1)}
.search_btn span {font-size: 14px;font-weight: 500;color: rgba(255, 255, 255, 1)}
.search_input {margin-left: 20px}
.search_input input {padding: 0 15px;height: 32px;border: 1px solid rgba(219, 219, 219, 1);border-radius: 4px;font-size: 14px;font-weight: 400;color: rgba(40, 40, 40, 1)}

.page_overview_header_note {margin: 40px 20px 0;z-index: 1}
.page_overview_header_note_icon {margin-left: 10px;cursor: pointer}
.page_overview_header_note_icon:hover >>> svg {fill: rgba(76, 139, 255, 1)}
.page_overview_header_note_info {text-align: left;align-items: flex-start;flex-flow: column;background-color: rgba(63, 70, 77, 1);border-radius: 4px;padding: 12px 16px}
.page_overview_header_note_info span {line-height: 1.3;font-size: 14px;font-weight: 400;color: rgba(255, 255, 255, 1)}
.page_overview_header_note_info .page_overview_header_note_info_header span {font-size: 18px}
.page_overview_header_note_info_content {align-items: flex-start;margin-top: 16px;justify-content: flex-start}
.page_overview_header_note_info_container {flex-flow: column;align-items: flex-start}
.page_overview_header_note_info_content_main {word-break: break-all;margin-left: 14px}
.page_overview_header_note_info_content_label {white-space: nowrap}

.account_page_detail .page_user_container:nth-of-type(1) .page_user_info {width: 86px}
.account_page_detail .page_user_container:nth-of-type(2) .page_user_info {min-width: 100px;max-width: 222px}
.account_page_detail .page_user_container:nth-of-type(3) .page_user_info {width: 100px}
.account_page_detail .page_user_container:nth-of-type(4) .page_user_info {min-width: 100px;max-width: 120px}
.account_modal .page_user_container.more_detail {cursor: pointer;margin-left: auto;margin-right: 20px}
.more_detail:hover span, .more_detail_active span {color: rgba(76, 139, 255, 1)}
.more_detail:hover >>> svg, .more_detail_active >>> svg {fill: rgba(76, 139, 255, 1)}
.more_detail_icon {margin-left: 8px}
.more_detail_icon >>> svg {width: 0.75em;height: 0.75em}

.no_user_hint {margin: 30px 0}
.no_user_hint span {font-size: 16px;font-weight: 500;color: rgba(143, 143, 143, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-user/user.vue